module.exports = __webpack_public_path__ + "img/e-done.9b073e51.svg";